// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"917cfe77","769":"70f3b610"}[chunkId] + ".chunk.css";
};